/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgDisclosureCode } from '../../models/esg-disclosure-code';
import { EsgDisclosureDatapoint } from '../../models/esg-disclosure-datapoint';
import { EsgDisclosureDatapointId } from '../../models/esg-disclosure-datapoint-id';

export interface DatapointByProfileByYearByCodeByDatapointIdGet$Params {
  profileId: number;
  year: number;
  code: EsgDisclosureCode;
  dataPointId: EsgDisclosureDatapointId;
}

export function datapointByProfileByYearByCodeByDatapointIdGet(http: HttpClient, rootUrl: string, params: DatapointByProfileByYearByCodeByDatapointIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgDisclosureDatapoint>> {
  const rb = new RequestBuilder(rootUrl, datapointByProfileByYearByCodeByDatapointIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.path('dataPointId', params.dataPointId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgDisclosureDatapoint>;
    })
  );
}

datapointByProfileByYearByCodeByDatapointIdGet.PATH = '/esg/profile/{profileId}/{year}/{code}/{dataPointId}';
